import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb503a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container w-75" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "active-note-taker"
}
const _hoisted_4 = { class: "alert-msg" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "form-container"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "alert-msg" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsHeader = _resolveComponent("DetailsHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Table = _resolveComponent("Table")!
  const _component_DetailsRow = _resolveComponent("DetailsRow")!
  const _component_PersonDetails = _resolveComponent("PersonDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DetailsHeader, {
      title: _ctx.$t('shared.routes.student-details'),
      onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToOverview())),
      onPrevious: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToStudent(_ctx.previousStudentId))),
      onNext: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToStudent(_ctx.nextStudentId)))
    }, null, 8, ["title"]),
    _createElementVNode("form", _hoisted_2, [
      (_ctx.isActiveNoteTaker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                innerHTML: _ctx.showNameMsg('student-details.activeNoteTaker')
              }, null, 8, _hoisted_5),
              _createVNode(_component_router_link, {
                to: {
              name: 'NoteTakerDetails',
              params: { id: _ctx.noteTakerId },
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("shared.routes.note-taker-details")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.student !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_PersonDetails, {
              person: _ctx.student,
              coordinator: _ctx.student.coordinator,
              functionId: this.functionId,
              showCoordinator: true,
              showEditButton: !_ctx.isActiveNoteTaker,
              requiredCoordinator: false,
              updateOnChange: _ctx.supportCourseOccurrencesFlat,
              saveButtonDisabled: _ctx.hasLaterStartDates,
              onEditEnable: _ctx.edit,
              onCancelEdit: _ctx.cancel,
              onSaveEdit: _ctx.save,
              onNewCoordinator: _ctx.updateStudent
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DetailsRow, { caption: "shared.courses" }, {
                  default: _withCtx(() => [
                    (_ctx.hasLaterStartDates)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.laterStartDateText), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Table, {
                      rows: _ctx.supportCourseRows,
                      hiddenColumns: _ctx.hiddenSupportCourseColumns,
                      ascending: _ctx.ascending,
                      "onUpdate:ascending": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ascending) = $event)),
                      sortColumn: _ctx.sortColumn,
                      "onUpdate:sortColumn": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sortColumn) = $event)),
                      onSortChanged: _ctx.onSortChange
                    }, {
                      td: _withCtx((data) => [
                        (data.col === 'courseOccurrenceId')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("course-occurrence.support")), 1))
                          : _createCommentVNode("", true),
                        (data.col === 'status')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("course-occurrence.status")), 1))
                          : (data.col === 'occurrence')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("course-occurrence.occurrence")), 1))
                            : (data.col === 'courseOccurrenceStart')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("course-occurrence.courseStartDate")) + " " + _toDisplayString(_ctx.$t("course-occurrence.abbreviation")), 1))
                              : (data.col === 'coordinatorName')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("course-occurrence.coordinatorName")), 1))
                                : _createCommentVNode("", true)
                      ]),
                      default: _withCtx((data) => [
                        (data.col === 'courseOccurrenceId')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createVNode(_component_CheckboxInput, {
                                class: "pb-3 ml-1",
                                checked: _ctx.supportCourseOccurrencesFlat[data.row.courseUid],
                                title: _ctx.getTitle(data.row.courseUid),
                                disabled: 
                      !_ctx.editEnable ||
                      data.row.courseOccurrenceStart ===
                        '0001-01-01T00:00:00' ||
                      _ctx.isCompletedCourse(data.row.courseUid)
                    ,
                                onUpdate: 
                      (value) =>
                        (_ctx.supportCourseOccurrencesFlat[data.row.courseUid] =
                          value)
                    
                              }, null, 8, ["checked", "title", "disabled", "onUpdate"])
                            ]))
                          : _createCommentVNode("", true),
                        (data.col === 'status')
                          ? (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 1,
                              text: _ctx.statusBgText(data.val),
                              bgColor: _ctx.statusBgColor(data.val)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Badge, {
                                  rounded: true,
                                  backgroundColor: _ctx.statusBgColor(data.val)
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_15
                                  ]),
                                  _: 2
                                }, 1032, ["backgroundColor"])
                              ]),
                              _: 2
                            }, 1032, ["text", "bgColor"]))
                          : _createCommentVNode("", true),
                        (data.col === 'occurrence')
                          ? (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 2,
                              class: _normalizeClass(
                    _ctx.isCourseWithLaterStartDate(data.row.courseUid)
                      ? 'highlighted-course'
                      : ''
                  ),
                              text: _ctx.getCourseTitle(data.row.titleSv, data.row.titleEn),
                              bgColor: _ctx.tooltipBgColor
                            }, {
                              default: _withCtx(() => [
                                (data.row.courseOccurrenceId !== 0)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: {
                      name: 'CourseOccurrenceDetails',
                      params: {
                        id: data.row.courseOccurrenceId,
                      },
                    }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.val), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass(
                      _ctx.isCourseWithLaterStartDate(data.row.courseUid)
                        ? 'highlighted-course'
                        : ''
                    )
                                    }, _toDisplayString(data.val), 3))
                              ]),
                              _: 2
                            }, 1032, ["class", "text", "bgColor"]))
                          : _createCommentVNode("", true),
                        (data.col === 'courseOccurrenceStart' && data.val)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              class: _normalizeClass(
                    _ctx.isCourseWithLaterStartDate(data.row.courseUid)
                      ? 'highlighted-course'
                      : ''
                  )
                            }, _toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 3))
                          : _createCommentVNode("", true),
                        (data.col === 'coordinatorName')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              class: _normalizeClass(
                    _ctx.isCourseWithLaterStartDate(data.row.courseUid)
                      ? 'highlighted-course'
                      : ''
                  )
                            }, _toDisplayString(data.val), 3))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["rows", "hiddenColumns", "ascending", "sortColumn", "onSortChanged"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["person", "coordinator", "functionId", "showEditButton", "updateOnChange", "saveButtonDisabled", "onEditEnable", "onCancelEdit", "onSaveEdit", "onNewCoordinator"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}